export enum ModalHeaderEnum {
  ADD = 'Add',
  EDIT = 'Edit',
}
